import { ReactComponent as WalletBalanceIcon } from 'assets/WalletBalanceIcon.svg';
import Button from 'components/Buttons/Button';
import Render from 'components/Common/Render';
import {
  balanceCardButtonClassName,
  balancePromoCardSurfaceClassName,
  formatCurrencyAmount,
} from 'components/Home/balanceCardSurface';
import { routes } from 'constants/routes';
import useMixpanel from 'hooks/useMixpanel';
import { useNavigate } from 'react-router-dom';

interface TopupDetailsProps {
  businessStats: BusinessStatsType;
  business: BusinessType;
  plans: BusinessPlanType[];
  setShowTransferDialog: (transferAmount: number) => void;
}

const TopupDetails: React.FC<TopupDetailsProps> = ({
  businessStats,
  plans,
  setShowTransferDialog,
}) => {
  const navigate = useNavigate();
  const { trackEvent } = useMixpanel();

  if (!(!!businessStats?.entityTransactionsCount || !!businessStats?.walletBalance)) {
    return null;
  }

  const walletBalance = businessStats?.walletBalance || 0;

  return (
    <div className={balancePromoCardSurfaceClassName}>
      <div className="flex flex-1 flex-col gap-5">
        <div className="font-poppins text-2xl font-semibold leading-none text-white">
          Wallet Balance
        </div>
        <div className="flex items-center gap-2">
          <WalletBalanceIcon className="h-10 w-10 shrink-0" />
          <span className="font-poppins text-[40px] font-bold leading-none text-white">
            ${formatCurrencyAmount(walletBalance)}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <Button
          label="Transaction History"
          type="button"
          variant="secondary"
          customClass={balanceCardButtonClassName}
          onClick={() => {
            trackEvent('topup_history_button_Clicking');
            navigate(routes.topupHistory);
          }}
        />
        <Render when={!!walletBalance && !!plans?.length}>
          <Button
            onClick={() => {
              trackEvent('transfer_balance_button_Clicking', {
                balance: walletBalance,
              });
              setShowTransferDialog(walletBalance);
            }}
            label="Transfer Balance"
            type="button"
            variant="secondary"
            customClass={balanceCardButtonClassName}
          />
        </Render>
      </div>
    </div>
  );
};

export default TopupDetails;
